// MEE - Mobile Employee Experience app a.k.a. Viva Connections
const VivaConnectionsAppName = 'MEE App';

type IsInVivaConnectionsApp = () => boolean;
export const isInVivaConnectionsApp: IsInVivaConnectionsApp = () =>
  navigator.userAgent.includes(VivaConnectionsAppName);
